export default __webpack_public_path__ + "static/media/g_wdt_c_4_5.080b1c11.mp3";